<template>
  <v-card>
    <v-container>
      <v-layout wrap>
        <v-flex
          xs12
          sm6
        >
          <v-text-field
            v-model="$currentUser.email"
            label="Email"
            disabled
          />
        </v-flex>

        <v-flex
          xs12
          sm6
        >
          <v-text-field
            v-model="$currentUser.profile.displayName"
            :label="$t('name')"
          />
        </v-flex>

        <v-flex
          xs12
          sm6
        >
          <v-text-field
            v-model="$currentUser.profile.jobTitle"
            label="Job Title"
          />
        </v-flex>

        <v-flex
          xs12
          sm6
        >
          <v-text-field
            v-model="$currentUser.profile.photoURL"
            label="Photo URL"
          />
          <img :src="$currentUser.profile.photoURL">
        </v-flex>

        <!-- Custom Properties -->
        <v-flex
          v-for="customProp in customProperties('user')"
          :key="`custom-prop-${customProp.id}`"
          xs12
          sm6
        >
          <pa-custom-property-field
            v-model="activityEdit[customProp.key]"
            :custom-prop="customProp"
          />
        </v-flex>

        <v-flex
          v-if="$can('organization')"
          xs12
          class="text-center"
        >
          <v-btn
            outlined
            small
            :to="{ name: 'organization-fields' }"
          >
            <v-icon left>
              add
            </v-icon>
            Add a custom field
          </v-btn>
        </v-flex>

        <v-flex xs12>
          <v-btn
            v-if="false"
            @click="linkGoogleAccount"
          >
            Connect Google Account
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-card-actions>
      <v-btn
        text
        :disabled="$currentUser.loading || $currentUser.saving"
        @click="cancel()"
      >
        Cancel
      </v-btn>

      <v-spacer />

      <v-btn
        color="success"
        :loading="$currentUser.loading"
        :disabled="$currentUser.loading || $currentUser.saving"
        @click="save()"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

import PaCustomPropertyField from '@/components/shared/PaCustomPropertyField'

export default {
  components: {
    PaCustomPropertyField
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('organizations', [ 'customProperties' ])
  },
  mounted () {
    this.cancel()
  },
  methods: {
    save () {
      this.$currentUser.save()
    },
    cancel () {
      this.$currentUser.reset()
    }
  }
}
</script>
